
















































import Login from "./componentes/Login.vue";
import state from "./state";

export default {
  data() {
    return {
      state,
    };
  },
  components: {
    Login,
  },
};
